<template>
	<section id="intro">
		<div class="container">
			<header class="major">
				<h2>Coding is awesome!</h2>
				<p style="text-align:bottom;"><img style="float: left; margin: 0px 15px 15px 0px;" src="images/martin-fowler.jpg" width=150 height=150 alt=""/>
				<i>A fool can write code a machine understands. A good programmer writes code a human can understand - <a target="_blank" href="http://martinfowler.com/">Martin Fowler</a></i></p>
			</header>
			<p>Am a software developer pursuing challenging and fulfilling career in information technology founded on efficiency,  delivery of quality service, ethical practice and maintenance of high professional standards.</p>
		</div>
	</section>
</template>